import classNames from "classnames";
import React from "react";
import styled from "styled-components";
import { ButtonProps } from "types/ButtonProps";

interface MyButtonProps {
  highlighted?: boolean;
}

type BaseButtonProps = MyButtonProps & ButtonProps;

export const Button = React.forwardRef<HTMLButtonElement, BaseButtonProps>(
  ({ highlighted = false, children, onClick, ...props }, ref) => {
    return (
      <OuterContainer
        highlighted={highlighted}
        ref={ref}
        onTouchStart={(e) => {
          e.preventDefault(); // prevents synthetic onClick firing
          onClick?.(e as any);
        }}
        onClick={(e) => {
          // ignore click if it's from touch
          if ((e as any).nativeEvent.pointerType === "touch") return;
          onClick?.(e);
        }}
        {...props}
      >
        {children}
      </OuterContainer>
    );
  },
);

const OuterContainer = styled.button.attrs<MyButtonProps>(({ highlighted }) => ({
  className: classNames(highlighted && "highlighted"),
}))<MyButtonProps>`
  background-color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer !important;
  box-shadow: 0px 0px 3px 0px;
  padding: 5px;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    filter: brightness(115%);
  }
  &:active {
    filter: brightness(105%);
  }
  &.highlighted {
    border: 3px solid var(--primary);
  }
  &:disabled {
    pointer-events: none;
    opacity: 50%;
    z-index: 0;
  }
`;
